import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/MediaModule/MediaModule.tsx");
